import axios from 'axios'
const config = {
    // proxy: "https://test-ycym.ship56.net/ycym-service" //服务器配置
    // proxy: "http://211.152.57.172:8989/ycym-service" //代理配置
    proxy: "http://211.152.57.173:8810",
    // Settle_inproxy: " http://crm.dev.ship56.net:8080"

};
//axios基本配置
const api = axios.create({
    timeout: 10000,
    withCredentials: true
});

//请求拦截
api.interceptors.request.use(
    conf => {
        //         //请求带token
        //         //conf.headers["Authorization"] = {}("accesstoken");
        return conf;
    },
    error => ({ status: 0, msg: error.message })
);
//返回拦截
api.interceptors.response.use(
    response => {
        return Promise.resolve(response).then(checkCode);
    },
    error => {
        window.console.log(error);
        checkStatus(error.response);
        return Promise.reject(error);
    }
);

// http状态码错误处理
const checkStatus = res => {
    // console.log(res)
    switch (res) {
        case 401:
            {
                //登录过期
                window.console.log("登录过期");
                break;
            }
        default:
            window.console.log("服务器存在异常", "middle");
            break;
    }
};

// 后台自定义 code错误处理
const checkCode = res => {
    if (res) {
        // console.log(res, "code")
        const data = res.data;
        if (data.code === 0) {
            return data.data;
        } else {
            window.console.log(res.data.msg); //统一处理错误
            return false;
        }
    } else {
        return false;
    }
};

// 解析参数
const formatParams = (method = "GET", params) => {
    //headers配置
    const headers = {
        "Content-Type": "application/json;charset=utf-8"
            // "Content-Type": "application/x-www-form-urlencoded"
    };
    switch (method) {
        case "POST":
            return {
                headers,
                method,
                data: params
            };
        case "PUT":
            return {
                headers,
                method,
                data: params
            };
        case "DELETE":
            return {
                headers,
                method
            };
        case "GET":
            return {
                headers,
                method,
                params
            };
        default:
            return {
                headers,
                method,
                params
            };
    }
};

export { api, formatParams, config };